module.exports = __webpack_public_path__ + "static/img/inv-3.6023370.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/landing/inv-3.png
// module id = nnmV
// module chunks = 0